import { useContext } from 'react'

import { MrpPurchaseContext } from '@provider/Mrp/PurchaseProvider'

import type { IMrpPurchaseContext } from '@base/@types/providers/Mrp/PurchaseProvider'

export default function useMrpPurchase(): IMrpPurchaseContext {
  const context = useContext(MrpPurchaseContext)

  return context
}
